import anime from 'animejs';
import FullScreenScroll from './fullScreenScroll';
import technologiesData from './technologies';
import { shuffleArray, isMobile } from './helpers';

class App {
	constructor() {
		this.setupTabs();
		this.setupTechCloud();

		this.handleFullscreenViewScroll();
	}

	resetAnimations: boolean = false;

	stormAnimation: anime.AnimeTimelineInstance;
	vinylAnimation: anime.AnimeTimelineInstance;
	aboutAppearAnim: anime.AnimeTimelineInstance;
	realizeAppearAnimation: anime.AnimeTimelineInstance;
	layersAppearAnimation: anime.AnimeTimelineInstance;

	handleLogoAppear() {
		const anim = anime({
			targets: ['.we-are.ready'],
			translateX: [-420, 0],
			translateZ: 0,
			opacity: [0, 1],
			easing: "easeOutExpo",
			duration: 500,
			delay: 0
		});
	}

	handleMenuItemsAppear() {
		const anim = anime.timeline({
			loop: false
		})
			.add({
				targets: '#sidebar ul li',
				translateX: [60, 0],
				// translateZ: 0,
				// rotateY: [-90, 0],
				opacity: [0, 1],
				easing: "easeInElastic",
				// easing: "cubicBezier(.36,-0.64,.34,1.76)",
				duration: 800,
				delay: (anime as any).stagger(150, {
					start: 700
				})
				// delay: (el, i) => {
				// 	return 700 + 50 * i;
				// }
			});
		// console.log(anim)
	}

	handleFullscreenViewScroll() {
		const scroll = new FullScreenScroll();
		let prevPosition = null;

		this.handleTitleAppear();
		this.handleMenuItemsAppear();
		// this.handleLogoAppear();
		this.handleStormAppear();
		this.handleVinylAnimation();

		scroll.registerCurrentPositionListener((currentPosition: number) => {
			if (currentPosition === null || currentPosition < 0 || prevPosition === currentPosition) {
				return;
			} else {
				this.handleTitleAppear(`.section${currentPosition + 1}`);
				// this.handlePerexAppear(`.section${currentPosition + 1}`);
			}

			// this.stormAnimation = null;
			// this.vinylAnimation = null;
			this.toggleStormAnimation(true);
			this.toggleVinylAnimation(true);

			if (currentPosition === 0) {
				this.toggleStormAnimation();
			}

			if (currentPosition === 1) {
				this.toggleVinylAnimation();
			}

			if (currentPosition === 2) {
				this.handleAboutAppear();
			}

			if (currentPosition === 3) {
				this.handleLayersAppear();
			}

			if (currentPosition === 4) {
				this.handleRealizeAppear();
			}

			prevPosition = currentPosition;
			// console.log('current position changed from: ', prevPosition, 'to: ', currentPosition)
		});
	}

	handleTitleAppear(targetSection: string = '.section1') {
		const targetSectionEl = document.querySelector(targetSection);
		if (!this.resetAnimations && targetSectionEl && targetSectionEl.className.includes('done')) {
			return;
		}

		const anim = anime.timeline({
			loop: false
		})
			.add({
				targets: [`${targetSection} h1 span`, `${targetSection} h2 span`],
				translateX: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 2500,
				delay: (el, i) => {
					return 700 + 35 * i;
				}
			});

		this.handleThisWayAppear(targetSection)

		if (targetSection === '.section1') {
			const usAnim = anime.timeline({
				loop: false
			})
				.add({
					targets: `.us`,
					translateX: [isMobile ? 0 : 300, 0],
					translateY: [isMobile ? -300 : 0, 0],
					opacity: [0, 1],
					easing: "easeOutExpo",
					duration: 2500,
					delay: 900
				})
				.add({
					targets: `.us h3`,
					translateY: [80, 0],
					translateZ: 0,
					opacity: [0, 1],
					easing: "easeOutExpo",
					duration: 2500,
					delay: 300
				});
		}

		if (targetSection === '.section7') {
			const contactSubtitlesAnim = anime.timeline({
				loop: false
			})
				.add({
					targets: `.section7 h3 span`,
					translateX: [40, 0],
					translateZ: 0,
					opacity: [0, 1],
					easing: "easeOutExpo",
					duration: 2500,
					delay: (anime as any).stagger(70, {
						start: 500
					})
				});
			const contactTextsAnim = anime.timeline({
				loop: false
			})
				.add({
					targets: `.contact-appear`,
					translateX: [-80, 0],
					translateZ: 0,
					opacity: [0, 1],
					easing: "easeOutQuad",
					duration: 900,
					delay: (anime as any).stagger(120, {
						start: 800
					})
				})
				.add({
					targets: '.contact-svg > path',
					strokeDashoffset: [anime.setDashoffset, 0],
					// strokeDasharray: '7',
					easing: 'easeInOutSine',
					duration: 1200,
					direction: 'alternate',
					delay: (anime as any).stagger(400, {
						start: 900
					}),
				});

			// const contactBgAnim = anime.timeline({
			// 	loop: true,
			// })
			// .add({
			// 	targets: '.contact-svg > g > path',
			// 	translateX: [0, -40],
			// 	easing: 'linear',
			// 	duration: 1200,
			// 	direction: 'normal',
			// 	delay: (anime as any).stagger(300, {
			// 		start: 0
			// 	}),
			// })
			// .add({
			// 	targets: '.contact-svg > g > path',
			// 	translateX: [-40, 0],
			// 	easing: 'linear',
			// 	duration: 1200,
			// 	direction: 'normal',
			// 	// delay: (anime as any).stagger(1600, {
			// 	// 	start: 0
			// 	// }),
			// })

			const contactBgAnim2 = anime.timeline({
				loop: false,
			})
				.add({
					targets: '.contact-svg > g',
					// strokeDashoffset: [anime.setDashoffset, 0],
					// strokeDasharray: '7',
					opacity: [0, 1],
					translateX: [-80, 0],
					easing: 'easeInOutSine',
					duration: 1200,
					direction: 'alternate',
					delay: (anime as any).stagger(400, {
						start: 900
					})
				})
				.add({
					targets: '.contact-svg > g > g',
					opacity: [0, .24],
					// strokeDashoffset: [anime.setDashoffset, 0],
					easing: 'easeInOutSine',
					duration: 1200,
					direction: 'normal',
					delay: (anime as any).stagger(1600, {
						start: 900
					}),
				})
			// .add({
			// 	targets: '.contact-svg .movable',
			// 	translateX: [40, 0],
			// 	easing: 'easeInExpo',
			// 	duration: 1200,
			// 	direction: 'normal',
			// 	delay: (anime as any).stagger(1600, {
			// 		start: 0
			// 	}),
			// })
		}

		this.handlePerexAppear(targetSection);
	}

	handleThisWayAppear(targetSection: string) {
		const anim = anime.timeline({
			loop: false
		})
			.add({
				targets: [`${targetSection} .this-way`],
				translateX: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 2500,
				delay: 800
			});
	}

	handlePerexAppear(targetSection: string) {
		const targetSectionEl = document.querySelector(targetSection);
		if (!this.resetAnimations && targetSectionEl && targetSectionEl.className.includes('done')) {
			return;
		}

		const anim = anime.timeline({
			loop: false
		})
			.add({
				targets: [`${targetSection} .perex`],
				translateX: [-80, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutQuad",
				duration: 900,

				delay: (el, i) => {
					return 1200 + 700 * i;
				}
			}).finished.then(() => {
				targetSectionEl && !this.resetAnimations ? targetSectionEl.className += ' done' : false;
			});

		if (targetSection === '.section2') {
			anime({
				targets: '.section2 li',
				opacity: [0, 1],
				easing: "easeInQuad",
				duration: 900,
				delay: (anime as any).stagger(200, {
					start: 600
				})
			});
		}

		if (targetSection === '.section3') {
			anime({
				targets: '.section3 li',
				opacity: [0, 1],
				easing: "easeInQuad",
				duration: 900,
				delay: (anime as any).stagger(200, {
					start: 600
				})
			});
		}

		if (targetSection === '.section4') {
			anime({
				targets: '.section4 h3, .section4 img',
				opacity: [0, 1],
				easing: "easeInQuad",
				duration: 900,
				delay: (anime as any).stagger(200, {
					start: 600
				})
			});
		}

		if (targetSection === '.section6') {
			anime({
				targets: '.references li',
				opacity: [0, 1],
				easing: "easeInQuad",
				duration: 900,
				delay: (anime as any).stagger(200, {
					start: 600
				})
			});
		}

		if (targetSection === '.section8') {
			anime({
				targets: 'h3, p, nav.nav-tab',
				opacity: [0, 1],
				easing: "easeInQuad",
				duration: 900,
				delay: (anime as any).stagger(50, {
					start: 600
				})
			});
		}
	}

	handleStormAppear() {
		if (isMobile) {
			return;
		}

		const anim = anime.timeline({
			loop: false
		})
			.add({
				targets: '#storm > g > g',
				translateX: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 2500,
				delay: (el, i) => {
					return 700 + 30 * i;
				}
			}).finished.then(() => {
				this.handleStormAnimation();
			});
	}

	handleStormAnimation() {
		if (this.stormAnimation || isMobile) {
			return;
		}

		this.stormAnimation = anime.timeline({
			loop: true,
		})
			.add({
				targets: '#storm > g > g',
				translateX: [0, -5],
				translateZ: 0,
				easing: "easeOutExpo",
				duration: 800,
				delay: (el, i) => {
					return 250 + 40 * i;
				}
			})
			.add({
				targets: '#storm > g > g',
				translateX: [-5, 0],
				translateZ: 0,
				easing: "easeInExpo",
				duration: 800,
				delay: (el, i) => {
					return 250 + 40 * i;
				}
			});
	}

	toggleStormAnimation(pause: boolean = false) {
		if (isMobile) {
			return;
		}

		if (this.stormAnimation && pause && !this.stormAnimation.paused) {
			// anime.remove(this.stormAnimation)
			this.stormAnimation.pause();
			// console.log('paused', this.stormAnimation)

			return;
		} else if (this.stormAnimation && !pause && this.stormAnimation.paused) {
			this.stormAnimation.play();
			// console.log('unpaused', this.stormAnimation)

			return;
		}
	}

	handleVinylAnimation() {
		if (isMobile || this.vinylAnimation) {
			return;
		}

		this.vinylAnimation = anime.timeline({
			loop: true,
		})
			.add({
				targets: '.vinyl-svg > path',
				translateX: [0, -15],
				translateZ: 0,
				easing: "easeOutBounce",
				duration: 600,
				delay: (el, i) => {
					return 250 + 30 * i;
				}
			})
			.add({
				targets: '.vinyl-svg > path',
				direction: 'reverse',
				translateX: [-15, 0],
				translateZ: 0,
				easing: "easeInBounce",
				duration: 600,
				delay: (el, i) => {
					return 250 + 30 * i;
				}
			});
	}

	toggleVinylAnimation(pause: boolean = false) {
		if (isMobile) {
			return;
		}

		if (this.vinylAnimation && pause && !this.vinylAnimation.paused) {
			this.vinylAnimation.pause();
			// console.log('paused', this.vinylAnimation)

			return;
		} else if (this.vinylAnimation && !pause && this.vinylAnimation.paused) {
			this.vinylAnimation.play();
			// console.log('unpaused', this.vinylAnimation)

			return;
		}
	}

	handleAboutAppear() {
		if (!this.resetAnimations && this.aboutAppearAnim) {
			return;
		}

		this.aboutAppearAnim = anime.timeline({
			loop: false
		})
			// Group 1
			// .add({
			// 	targets: '.about-svg .about-g-1 > circle',
			// 	opacity: [0, 1],
			// 	easing: 'linear',
			// 	duration: 400,
			// 	delay: 100,
			// })
			.add({
				targets: '.about-svg .about-g-1',
				translatex: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: 'easeOutQuad',
				duration: 100,
				delay: (el, i) => {
					return 150 * i;
				},
			})
			.add({
				targets: '.about-svg .about-path-1',
				strokeDashoffset: [anime.setDashoffset, 0],
				strokeDasharray: '7',
				easing: 'easeInOutSine',
				duration: 500,
				delay: 10,
				direction: 'alternate',
			})

			// Group 2
			// .add({
			// 	targets: '.about-svg .about-g-2 > circle',
			// 	opacity: [0, 1],
			// 	easing: 'linear',
			// 	duration: 500,
			// 	delay: (el, i) => {
			// 		return 300 * i;
			// 	}
			// })
			.add({
				targets: '.about-svg .about-g-2',
				translateX: [-40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: 'easeOutQuad',
				duration: 500,
				delay: (el, i) => {
					return 250 * i;
				},
			})
			.add({
				targets: '.about-svg .about-path-2',
				strokeDashoffset: [anime.setDashoffset, 0],
				strokeDasharray: '7',
				easing: 'easeInOutSine',
				duration: 500,
				delay: 10,
				direction: 'reverse',
			})
			// Group 3
			// .add({
			// 	targets: '.about-svg .about-g-3 > circle',
			// 	opacity: [0, 1],
			// 	easing: 'linear',
			// 	duration: 500,
			// 	delay: (el, i) => {
			// 		return 300 * i;
			// 	}
			// })
			.add({
				targets: '.about-svg .about-g-3',
				translateX: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: 'easeOutQuad',
				duration: 500,
				delay: (el, i) => {
					return 250 * i;
				},
			})
			.add({
				targets: '.about-svg .about-path-3',
				strokeDashoffset: [anime.setDashoffset, 0],
				strokeDasharray: '7',
				easing: 'easeInOutSine',
				duration: 500,
				delay: 10,
				direction: 'normal',
			})
			// Group 4
			// .add({
			// 	targets: '.about-svg .about-g-4 > circle',
			// 	opacity: [0, 1],
			// 	easing: 'linear',
			// 	duration: 500,
			// 	delay: (el, i) => {
			// 		return 300 * i;
			// 	}
			// })
			.add({
				targets: ['.about-svg .about-g-4'],
				translateY: [-40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: 'easeOutQuad',
				duration: 500,
				delay: (el, i) => {
					return 250 * i;
				},
			})
	}

	handleRealizeAppear() {
		if (!this.resetAnimations && this.realizeAppearAnimation) {
			return;
		}

		this.realizeAppearAnimation = anime.timeline({
			loop: false
		})
			.add({
				targets: '.realize-svg > path',
				strokeDashoffset: [anime.setDashoffset, 7],
				strokeDasharray: '7',
				easing: 'easeInOutSine',
				duration: 1500,
				delay: function (el, i) {
					return i * 550
				},
				direction: 'alternate',
			})
			.add({
				targets: [`.realize-svg > g`],
				scale: [14, 1],
				opacity: [0, 1],
				easing: 'easeOutCirc',
				duration: 900,
				delay: (el, i) => {
					return 800 * i;
				}
			})
			.add({
				targets: '.tech-cloud li',
				opacity: [0, 1],
				// translateX: [-25, 0],
				// easing: "easeInExpo",
				easing: "easeInQuad",
				duration: 950,
				delay: function (el, i) {
					return 250 * i
				}
			}, -800);
	}

	handleLayersAppear() {
		if (!this.resetAnimations && this.layersAppearAnimation) {
			return;
		}

		document.querySelectorAll('.col- > i').forEach(element => {
			element.setAttribute('style', '');
		});


		(this.layersAppearAnimation as any) = anime.timeline({
			loop: false
		})
			.add({
				targets: [`.col- > i`],
				translateX: [-80, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutQuad",
				duration: 900,

				delay: (el, i) => {
					return 1200 + 700 * i;
				}
			})
			.add({
				targets: [`.layers-list > li > a`],
				translateX: [-80, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutQuad",
				duration: 900,
				delay: (el, i) => {
					return 1200 + 700 * i;
				}
			}, -200)
			.add({
				targets: [`.layers-list > li > a.active + div`],
				opacity: [0, 1],
				easing: "easeInQuad",
				duration: 700,
				delay: 500,
			}).finished.then(() => {
				// this.handleLayersAnimation();
			});
	}

	handleLayersAnimation() {
		const layersAnim = anime.timeline({
			loop: true,
		})
			.add({
				targets: '.col- .layer',
				translateY: [0, -30],
				easing: 'easeInElastic',
				duration: 2500,
				delay: (el, i) => {
					return 750 * i;
				}
			})
			.add({
				targets: '.col- .layer',
				translateY: [-30, 0],
				easing: 'easeOutElastic',
				duration: 2500,
				delay: (el, i) => {
					return 750 * i;
				}
			});

		return false
	}

	setupTabs() {
		const tabItems = document.querySelectorAll('.layers-list > li > a');

		for (let i = 0; i < tabItems.length; i++) {
			const element = tabItems[i];
			(element as HTMLElement).onclick = e => {
				tabItems.forEach(e => e.className = '');
				(e.srcElement as HTMLElement).className = 'active';
			}
		}
	}

	setupTechCloud() {
		const techCloud = document.querySelector('.tech-cloud');

		shuffleArray(technologiesData).map(t => {
			const techListItem = document.createElement('li');
			techListItem.innerText = t.name;
			techCloud.appendChild(techListItem);
		});
	}
}

export default App;
export { App };
